import { h } from './dom';

export function Footer(): HTMLElement {
  const links = h('span', {});
  links.append(
    h('a', { href: 'https://github.com/Damn1611', target: '_blank', rel: 'noopener noreferrer' }, 'github ↗'),
    '   ',
    h('a', { href: 'mailto:hello@damn.black' }, 'email ↗'),
  );

  return h('footer', { class: 's-footer' },
    h('div', { class: 's-footer__bar' },
      h('span', {}, '© 2026 — DAMN DEVELOPMENT'),
      h('span', {}, 'build damn good software.'),
      links,
    ),
  );
}
